define('modules/news_form/news_form_view',[
  'backbone',
  'jquery',
  '_',

  './news_form_model',

  'modules/form/CreateField',
  'modules/form/convert-form-data',

  'modules/loading/loading_spinner_view',

  'text!./news_form_template.html',
  'text!modules/form/form_section_template.html'
], function (Backbone, $, _,
             NewsFormModel,
             CreateField,
             convertFormData,
             Loading,
             news_form_template,
             news_form_section_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      _.extend(this, options);
      this.subViews = [];

      this.formModel = new NewsFormModel({id: this.news_item_id});

      this.dataModel = new Backbone.Model();

      this.render();

      this.listenTo(this.formModel, 'change', function (model) {

        this.render();
        this.renderSections();

        Backbone.trigger('render:form');
        Backbone.trigger('render:form:news_form');

        this.newsItemModel = new NewsFormModel({id: model.get('id')});

        this.listenTo(this.dataModel, 'change', function (model) {
          Backbone.trigger('formDirty', true);
        }, this);

        this.listenTo(this.newsItemModel, 'sync', function (model) {

          if (!model.get('error')) {
            Backbone.trigger('formDirty', false);
          }

          if (this.loading) {
            this.loading.done();
          }

          this.formModel.set(model.toJSON());

          this.showFormFeedback(model);
        }, this);

      }, this);

      this.formModel.fetch();

    },

    subViews: [],

    template: _.template(news_form_template),
    section_template: _.template(news_form_section_template),

    events: {
      'click .js-cancel-form': 'cancelForm',
      'submit .news-form': 'submitNewsForm'
    },

    render: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });

      this.subViews = [];

      this.$el.html(this.template(this.formModel.toJSON()));
      return this;
    },

    renderSections: function () {
      var $sections_html = $('<div />');

      var Field = CreateField.extend();

      this.formModel.get('sections').each(function (section) {
        var section_html = this.section_template(section.toJSON()),
          $section_html = $(section_html);

        var fields_html = [];

        section.get('fields').each(function (field) {

          var field_view = new Field({model: field, dataModel: this.dataModel});

          this.subViews.push(field_view);
          fields_html.push(field_view.$el);
        }, this);

        $section_html.find('.js-form-section-content').html(fields_html);

        $sections_html.append($section_html);

      }, this);

      this.$('.js-form-sections').html($sections_html);

      return this;
    },

    cancelForm: function (e) {
      e.preventDefault();
      Backbone.trigger('formDirty', false);
      Backbone.trigger('goBack', '/news');
    },

    submitNewsForm: function (e) {
      e.preventDefault();

      this.loading = new Loading();
      this.loading.start();

      this.newsItemModel.set(this.dataModel.toJSON());
      this.newsItemModel.save();
    },

    showFormFeedback: function (model) {
      if (model.get('error')) {
        this.$('.js-feedback').html('<div class="news-form-feedback news-form-feedback--error"><span class="icon-status-error"></span> ' + model.get('error_message') + '</div>');
      } else {
        this.$('.js-feedback').html('<div class="news-form-feedback news-form-feedback--ok"><span class="icon-status-success"></span> ' + _.t('newsform.feedback.news_item_saved') + '</div>');
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });

      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }

  });
  return View;
});

